common_ui = require('./modules/common_ui.js');
var slider = require('./modules/slider.js');
var header = require('./modules/header.js');
var footer = require('./modules/footer.js');
var fadein = require('./modules/fadein.js');
var gallery = require('./modules/gallery.js');

$(function() {
	common_ui.init();
	slider.init();
	header.hamburgerMenu();
	header.currentPage();
	fadein.init();

	// instagram
	gallery();

	window.addEventListener('resize', function() {
		common_ui.mediaSwitchImg();
	});

	// scroll button
	var scrollPos = $(window).scrollTop();
	footer.pageTopDisplay(scrollPos);
	footer.pageTopFixed(scrollPos);

	$(window).scroll(function(){
		scrollPos = $(window).scrollTop();
		footer.pageTopDisplay(scrollPos);
		footer.pageTopFixed(scrollPos);
	});

	// go to top
	$('.js_pageTop').on('click',function(){
		footer.gotoTop();
	});
});



//////////////////
// WEBPACK FOOTER
// ./src/resources/js/script.js
// module id = 1
// module chunks = 0